@if (form) {
    <form [formGroup]="form" fxLayout="column" fxLayoutAlign="center center" class="pr-56 pl-56 pb-48 pt-48 w-100">
        <div class="h3-semi-bold c-primary-gray-900"> {{ dialogData.title | translate }}</div>
        <div class="mt-16 t2 c-primary-gray-600 pre-wrap text-center" fxFlexAlign="start">
            {{ dialogData.subtitle | translate:{id: dialogData.id} }}
        </div>
        @if (showReason) {
            <div class="mt-16 w-100">
                <af-dictionary-selector dictionaryName="deleted_based"
                                        [control]="form.controls.reason"
                                        [filterDictionaryBy]="dialogData.reasonFilter"
                                        label="i18n_af_labelReason"
                                        placeholder="i18n_af_placeholderSelectReason"/>
            </div>
        }
        <div class="t5 c-primary-gray-600 mt-24" fxFlexAlign="start">{{ 'i18n_af_labelDeleteReason' | translate }}</div>
        <mat-form-field fxFlex class="w-100 mt-4">
      <textarea matInput
                maxlength="{{maxCommentLength}}"
                class="resize-none pt-12 pb-12"
                formControlName="comment"></textarea>
            <mat-hint align="end" class="t2 c-primary-gray-600">{{ form.controls.comment.value.length }} / {{ maxCommentLength }}</mat-hint>
        </mat-form-field>
        <ui-kit-button
            class="mt-12"
            color="accent"
            [disabled]="form.invalid"
            (clickListener)="dialogRef.close(form.value)"
            [label]="'i18n_af_buttonDelete' | translate"/>
        <ui-kit-button
            class="mt-16"
            type="text"
            (clickListener)="dialogRef.close()"
            [label]="'i18n_af_buttonCancel' | translate"/>
    </form>
}
